import { createFileRoute } from '@tanstack/react-router';
import Candidates from '@/scenes/Candidates';
export const Route = createFileRoute('/_auth/applications/$sessionId')({
  component: Applications,
  // ?application=<id> opens that application's details (links from the Feedback page)
  validateSearch: (search: Record<string, unknown>): { application?: string } => ({
    application: typeof search.application === 'string' ? search.application : undefined,
  }),
});

function Applications() {
  return (
    <>
      <Candidates />
    </>
  );
}
